import React from 'react'

function TechSelectionSDL() {
  return (
    <embed src="\pdfs\E1.6.4.3_SD-L_Linear_step_twist_outlet_07.2014_kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectionSDL